export default function ({ store, route }) {
    let path = route.path.startsWith('/ro') ? route.path.slice(3) : route.path;

    if (!path) path = '/';

    store.commit('navigationHistory/ADD_TO_HISTORY', path);
}
